import React from "react";

import { mergeStyleSets } from "@fluentui/react";
import { useTranslation } from "react-i18next";

import NavigationComponent from "./NavigationComponent";
import { NavigationLinks } from "./NavigationLinks";
import { INavigationLink } from "./types";

interface Props {
  closeAppLuncher: () => void;
}

export const GosNavigation = ({ closeAppLuncher }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <h2
        className={classes.appHeader}
        style={{ marginBlockStart: "0.83em", marginBlockEnd: "0.83em" }}
      >
        {t("ram.appLauncher.header")}
      </h2>
      <div className={classes.container}>
        <div className={classes.navWrap}>
          {NavigationLinks(t).map((link: INavigationLink, index: number) => {
            return (
              <NavigationComponent
                key={link.id}
                id={link.id}
                link={link}
                index={index}
                closeAppLuncher={closeAppLuncher}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

const classes = mergeStyleSets({
  appHeader: { paddingLeft: "15px" },
  container: {
    padding: "12px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  navWrap: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
});
